<template>
  <v-container fluid class="rv-duration-page">
    <!-- Filter Section -->
    <div class="rv-duration-filter-section">
      <v-row no-gutters>
        <v-col md="4">
          <div class="rv-duration-filter-toggle">
            <div>
              <h5
                v-if="switchToAdvanceFilter == true"
                @click="switchToAdvanceFilter = false"
                style="cursor: pointer"
              >
                Switch to Normal Filter
              </h5>
              <h5
                v-if="switchToAdvanceFilter == true"
                @click="switchToAdvanceFilter = true"
                style="cursor: pointer"
              >
                Switch to Advance Filter
              </h5>
            </div>
            <div class="rv-duration-filter-btn">
              <h4 v-on:click="isShow = !isShow" style="float: left; cursor: pointer; margin: 0;">
                <v-icon small left>mdi-filter-variant</v-icon>
                Filter
                <v-icon small>mdi-menu-down</v-icon>
              </h4>
              <span v-if="switchToAdvanceFilter == false" class="rv-duration-filter-count">
                {{ conditions.length }} Filter Applied
              </span>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-2">
        <v-col md="12">
          <div v-show="isShow" class="rv-duration-filter-body">
            <div v-show="switchToAdvanceFilter == false">
              <BreadTabulatorFilterable
                ref="filter"
                :model="model"
                :setConditions="setConditions"
              ></BreadTabulatorFilterable>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>

    <!-- Search & Export Area -->
    <div class="rv-duration-search-area">
      <v-row align="center">
        <v-col md="6">
          <BreadTabulatorSearchable
            ref="search"
            :model="model"
            :setConditions="setConditions"
          ></BreadTabulatorSearchable>
          <div>
            <span id="record-count" class="rv-duration-record-count"></span>
          </div>
        </v-col>
        <v-col md="6" class="d-flex justify-end">
          <v-btn-toggle dense multiple class="mr-1">
            <BreadTabulatorExportAll
              ref="exportData"
              :model="model"
              :apiUrl="apiGetBrowseUrl()"
              @downloadData="downloadData"
            >
            </BreadTabulatorExportAll>
          </v-btn-toggle>
        </v-col>
      </v-row>
    </div>

    <!-- Data Table -->
    <div class="rv-duration-table-wrapper">
      <BreadTabulator
        ref="tabulatorDataTable"
        layout="fitColumns"
        :autoColumns="false"
        :paginationSize="paginationSize"
        :paginationSizeSelector="paginationSizeSelector"
        :apiUrl="apiGetBrowseUrl()"
        :columns="columns"
        :modelKey="modelKey"
        :columnSelectionDisabledCount="columnSelectionDisabledCount"
        :responsiveLayout="false"
        @getCurrentPageSize="getCurrentPageSize"
        @getCurrentSort="getCurrentSort"
        @getCurrentColumnWidth="getCurrentColumnWidth"
        @getCurrentPageNumber="getCurrentPageNumber"
      ></BreadTabulator>
    </div>
  </v-container>
</template>
<script>
import Api from "@/objects/api";
import { mapState } from "vuex";
import Model from "@/objects/model";
import Service from "@/objects/service";

export default {
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,

    }),
  },
  props: ["params"],
  data: () => ({
    api: new Api(),
    conditions: [],
    model: new Model(),
    service: new Service(),
    listAllViews: [],
    columns: [],
    paginationSize: 10,
    paginationSizeSelector: [10, 50, 100, 200],
    modelKey: "",
    parentId: "",
    cColumnSort: [],
    displayRowCount: 10,
    selectedCustomColums: [],
    selectedAdvanceFilterConditions: [],
    selectedFilterConditions: [],
    switchToAdvanceFilter: false,
    isShow: false,
    allResizeColumns: [],
    columnSelectionDisabledCount: 2,
    currentPageNo: 1,
  }),
  created() {
    this.model.getByKey(this.params.modelKey);
    if (this.model.serviceKey) this.service.set("key", this.model.serviceKey);
    this.modelKey = this.$route.params.modelKey;
    this.parentId = this.$route.params.parentId;

    this.columns = this.$_.filter(
      this.model.browse.table.headers,
      (headers) => {
        return headers;
      }
    );

    this.rolesAssignation(this.auth.roles);
  },
  mounted() {
    if (
      this.$route.query.viewId != "all" &&
      this.$route.query.viewId != "trashed"
    ) {
      const viewId = parseInt(this.$route.query.viewId, 10);
      this.getAllViews(viewId);
    }
    if (this.$route.query.viewId == "all") {
      this.getAllViews("all");
    }

    if (this.$route.query.viewId == "trashed") {
      this.getAllViews("trashed");
    }
  },
  methods: {
    getConditions() {
      return this.conditions;
    },
    setConditions(conditions) {
      this.selectedFilterConditions = conditions;
      this.conditions = conditions;
      this.$refs.tabulatorDataTable.getFilterCondition(conditions);
    },
    apiGetBrowseUrl() {
      let browseUrl = `${
        this.$service[this.service.key]
      }/v1/en/console/report/${this.model.child.durationAnalysisReport.key}`;

      // Check if user have salesperson role, then assign only this salesperson can see back own sales.
      if (this.isSalespersonRoles && this.auth.roles.length == 1) {
        browseUrl = browseUrl + `?email=${this.auth.email}`;
      }

      return browseUrl;
    },
    setFiltersViaConditions(conditions) {
      this.$refs.filter.setFiltersViaConditions(conditions);
    },
    getCurrentPageSize(pagesize) {
      this.displayRowCount = pagesize;
    },
    getCurrentSort(sorters) {
      this.cColumnSort = sorters;
      this.cColumnSort = sorters.map((sorter) => {
        return {
          column: sorter.field,
          dir: sorter.dir,
        };
      });
    },
    getCurrentColumnWidth(resizedColumns) {
      const resizedColumnField = resizedColumns.getField();
      const resizedColumnWidth = resizedColumns.getWidth();

      //set the resized column width and filed name to the array
      const resizedColumnWidthAndField = {
        field: resizedColumnField,
        width: resizedColumnWidth,
      };

      const index = this.allResizeColumns.findIndex((item) => {
        return item.field === resizedColumnField;
      });

      if (index !== -1) {
        this.allResizeColumns[index].width = resizedColumnWidth;
      } else {
        this.allResizeColumns.push(resizedColumnWidthAndField);
      }
    },
    changeTableDetails(listAllViews, viewId) {
      // get the view details from listAllViews where id is equal to viewId
      if (viewId == "trashed") {
        //this.$refs.tabulatorDataTable.clearTableData();
        this.$refs.tabulatorDataTable.callApiUrl(this.apiGetBrowseTrashUrl());
        this.$refs.selectColumn.showAllColumns([]);
        this.$refs.tabulatorDataTable.callSavedHeaderWidth([]);
        this.$refs.search.getFilterCondition([]); /// add this one
        this.$refs.customView.changeSelectedTabStatus("trashed", 0);
      } else if (viewId == "all") {
        //this.$refs.tabulatorDataTable.clearTableData();
        this.$refs.tabulatorDataTable.callSavedHeaderWidth([]);
        this.$refs.selectColumn.showAllColumns([]);
        this.$refs.search.getFilterCondition([]);
        this.$refs.customView.changeSelectedTabStatus("all", 1);
        this.setCurrentPageTo();
      } else {
        //console.log("other", this.$refs.tabulatorDataTable.getCurrentApiUrl());
        const tabIndex =
          listAllViews.indexOf(listAllViews.find((x) => x.id === viewId)) + 2;
        this.$refs.customView.changeSelectedTabStatus(viewId, tabIndex);
        const singleViewDetail = listAllViews.filter((item) => {
          return item.id === viewId;
        });

        if (singleViewDetail.length > 0) {
          if (
            JSON.parse(singleViewDetail[0].manageColumnCustomWidth).length > 0
          ) {
            this.$refs.tabulatorDataTable.callSavedHeaderWidth(
              JSON.parse(singleViewDetail[0].manageColumnCustomWidth)
            );
          }

          this.$refs.selectColumn.showViewSelectedColumns(
            JSON.parse(singleViewDetail[0].cColumnCondition)
          );

          // calling API
          if (JSON.parse(singleViewDetail[0].filterCondition).length > 0) {
            this.$refs.filter.setFiltersViaConditions(
              JSON.parse(singleViewDetail[0].filterCondition)
            );
          }

          // calling API
          if (JSON.parse(singleViewDetail[0].cColumnSort).length > 0) {
            this.$refs.tabulatorDataTable.callSavedColumnSort(
              JSON.parse(singleViewDetail[0].cColumnSort)
            );
          }

          // calling API
          if (singleViewDetail[0].displayRowCount != this.paginationSize) {
            this.$refs.tabulatorDataTable.callSavedPageSize(
              singleViewDetail[0].displayRowCount
            );
          }
          // add following one
          this.$refs.search.getFilterCondition(
            JSON.parse(singleViewDetail[0].filterCondition)
          );
        }

        this.setCurrentPageTo();
      }
    },
    getAllViews(viewId) {
      this.api.setMethod(`GET`);
      this.api.setUrl(
        `${this.$service.hrdc}/v1/en/console/crmView/list?modelKey=${this.model.key}`
      );
      this.api.setCallbackCompleted((response) => {
        // get all private views when the ouwnerUuid is equal to auth.uuid
        const privateViews = response.filter((view) => {
          return view.isPrivate === true && view.ownerUuid === this.auth.uuid;
        });

        // get all public views
        const publicViews = response.filter((view) => {
          return view.isPrivate === false;
        });

        // push all private and public views to listAllViews
        this.listAllViews = [...publicViews, ...privateViews];
        this.changeTableDetails(this.listAllViews, viewId);
      });
      this.api.fetch();
    },
    applyColumnSelection(selectedColumns) {
      this.selectedCustomColums = selectedColumns;
      this.$refs.tabulatorDataTable.applyColumnSelection(selectedColumns);
    },
    getCurrentPageNumber(pageno) {
      this.currentPageNo = pageno;
    },
    setCurrentPageTo() {
      var pageNo =
        this.$store.state.developer.data.paginationPageNo != null
          ? this.$store.state.developer.data.paginationPageNo
          : 1;
      this.$refs.tabulatorDataTable.tabulator.setPage(pageNo);
      this.$store.commit("assignDeveloperData", {
        paginationPageNo: null,
      });
    },
    downloadData(fileType, rowsType) {
      this.isLoading = true;

      switch (fileType) {
        case "csv":
          this.downloadCsvData(rowsType);
          break;
        case "xlsx":
          this.downloadExcelData(rowsType);
          break;
        case "pdf":
          this.downloadPdfData(rowsType);
          break;
        default:
          break;
      }
    },
    downloadCsvData(rowsType) {
      this.$refs.tabulatorDataTable.tabulator.download(
        "csv",
        `${this.model.key}.csv`,
        {
          sheetName: `${this.model.key}`,
        },
        rowsType == "selected" ? "selected" : "all"
      );
      this.isLoading = false;
      // unchecked all the selected rows
      this.$refs.tabulatorDataTable.tabulator.deselectRow();
    },
  },
};
</script>
<style scoped>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .rv-duration-filter-count {
  color: var(--app-text-muted);
  background: var(--app-elevated);
}

.dark-mode .rv-duration-filter-body {
  background: var(--app-surface);
  border: 1px solid var(--app-border);
}

.dark-mode .rv-duration-record-count {
  color: var(--app-text-muted);
}

.dark-mode .rv-duration-table-wrapper {
  background: var(--app-card);
  border: 1px solid var(--app-border);
}

/* >>> end auto-dark <<< */

/* ============================================
   PAGE LAYOUT
   ============================================ */
.rv-duration-page {
  font-family: 'Lato', sans-serif;
  padding: 20px 24px !important;
}

/* ============================================
   FILTER SECTION
   ============================================ */
.rv-duration-filter-section {
  margin-bottom: 16px;
}

.rv-duration-filter-toggle {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.rv-duration-filter-toggle h5 {
  font-family: 'Lato', sans-serif;
  font-size: 0.78rem;
  font-weight: 600;
  color: #0ea5e9;
  cursor: pointer;
  margin: 0;
}

.rv-duration-filter-toggle h5:hover {
  color: #0369a1;
}

.rv-duration-filter-btn {
  display: flex;
  align-items: center;
  gap: 12px;
}

.rv-duration-filter-btn h4 {
  font-family: 'Lato', sans-serif;
  font-size: 0.85rem;
  font-weight: 700;
  color: #3a3f47;
}

.rv-duration-filter-count {
  font-size: 0.75rem;
  font-weight: 500;
  color: #64748b;
  background: #f1f5f9;
  padding: 2px 10px;
  border-radius: 20px;
}

.rv-duration-filter-body {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 16px;
  margin-top: 8px;
}

/* ============================================
   SEARCH AREA
   ============================================ */
.rv-duration-search-area {
  margin-bottom: 16px;
}

.rv-duration-record-count {
  float: left;
  font-size: 0.75rem;
  color: #64748b;
  font-family: 'Lato', sans-serif;
}

/* ============================================
   TABLE WRAPPER
   ============================================ */
.rv-duration-table-wrapper {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
}
</style>

<style>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-header {
  background: var(--app-surface) !important;
  border-bottom: 2px solid var(--app-border) !important;
}

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-header .tabulator-col {
  background: var(--app-surface) !important;
  border-right: 1px solid var(--app-border) !important;
}

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-tableholder .tabulator-table .tabulator-row {
  border-bottom: 1px solid var(--app-border) !important;
}

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-tableholder .tabulator-table .tabulator-row:hover {
  background: var(--app-surface) !important;
}

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-tableholder .tabulator-table .tabulator-row .tabulator-cell {
  color: var(--app-text) !important;
  border-right: 1px solid var(--app-border) !important;
}

.dark-mode .rv-duration-table-wrapper .tabulator .tabulator-footer {
  background: var(--app-surface) !important;
  border-top: 2px solid var(--app-border) !important;
}

/* >>> end auto-dark <<< */

/* Tabulator overrides (unscoped for child component) */
.rv-duration-table-wrapper .tabulator {
  border: none !important;
  font-family: 'Lato', sans-serif !important;
}

.rv-duration-table-wrapper .tabulator .tabulator-header {
  background: #f8fafc !important;
  border-bottom: 2px solid #e2e8f0 !important;
}

.rv-duration-table-wrapper .tabulator .tabulator-header .tabulator-col {
  background: #f8fafc !important;
  border-right: 1px solid #e2e8f0 !important;
}

.rv-duration-table-wrapper .tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-title {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.75rem !important;
  font-weight: 700 !important;
  color: #3a3f47 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
}

.rv-duration-table-wrapper .tabulator .tabulator-tableholder .tabulator-table .tabulator-row {
  border-bottom: 1px solid #f1f5f9 !important;
  transition: background 0.15s ease;
}

.rv-duration-table-wrapper .tabulator .tabulator-tableholder .tabulator-table .tabulator-row:hover {
  background: #f8fafc !important;
}

.rv-duration-table-wrapper .tabulator .tabulator-tableholder .tabulator-table .tabulator-row .tabulator-cell {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.8rem !important;
  color: #334155 !important;
  border-right: 1px solid #f1f5f9 !important;
}

.rv-duration-table-wrapper .tabulator .tabulator-footer {
  background: #f8fafc !important;
  border-top: 2px solid #e2e8f0 !important;
}

.freeze-border-right {
  border-right: 1px solid black !important;
}
.claim-basis-end-border-right {
  border-right: 2px solid black !important;
}
.freeze-border-left {
  border-left: 1px solid black !important;
}
</style>
